import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContentManagementResourceService, RequestParameter } from 'src/app/services/EcmWebService';
import {
	AllegationVO,
	BaseCase,
	EventLogResponse,
	PrepaAllegationResourceService,
	PrepaCaseResourceService,
	PrepaEventLogResourceService,
	SystemicCaseCriteria,
	SystemicCriteriaCharges,
	SystemicResourceService,
} from 'src/app/services/gen';
import { SearchDataService } from 'src/app/services/search-data.service';
import { CaseRequestParam, PrepaSearchResourceService } from 'src/app/services/SearchDataWebService';
import { CaseDetailV2 } from 'src/app/shared/common-structures/case-detail';
import { DocumentsConfig } from '../documents/documents.config';
import { Pageable } from './../../../services/gen/model/pageable';

@Injectable({
	providedIn: 'root',
})
export class SharedPartiesService {
	public relatedCaseIdsList: number[] = [];
	public linkedCaseIdsList: number[] = [];
	public unLinkedCaseIdsList: number[] = [];

	constructor(
		private searchDataServ: SearchDataService,
		private caseServ: PrepaCaseResourceService,
		private allegationserv: PrepaAllegationResourceService,
		private contentManagementServ: ContentManagementResourceService,
		private eventLogServ: PrepaEventLogResourceService,
		private systemicServ: SystemicResourceService,
		private systemicEventLogServ: PrepaEventLogResourceService,
		private prepaSearchServ: PrepaSearchResourceService
	) {}

	searchCaseDetail(reqParam: CaseRequestParam, isExactMatch = false): Observable<CaseDetailV2[]> {
		const payload: CaseRequestParam = {
			isExactMatch: isExactMatch ? 'Y' : 'N',
			// celEventCode: "INQUIRY_SUBMITTED"
		};
		for (let entry of Object.entries(reqParam)) {
			if (entry[1]) {
				payload[entry[0]] = entry[1];
			}
		}
		return this.searchDataServ.searchCaseDetailV2(payload);
	}

	searchCaseDetailByIds(caseIdsString: string): Observable<CaseDetailV2[]> {
		return this.prepaSearchServ.searchCaseDetailByList(caseIdsString);
	}

	getCaseDetails(caseId: number): Observable<BaseCase> {
		return this.caseServ.getCaseDetails(caseId);
	}

	getDocumentsByCaseNumber(caseNumber: string, domain: string): Observable<any> {
		const params: RequestParameter = {
			appname: DocumentsConfig.appname,
			domain: domain,
			foldername: caseNumber,
		};
		return this.contentManagementServ.findDocuments(params);
	}

	downloadFile(caseNumber, docId): Observable<object> {
		const params = {
			appname: DocumentsConfig.appname,
			domain: 'PRIVATE',
			userName: 'mrichard',
			foldername: caseNumber,
			docid: docId,
		};
		return this.contentManagementServ.downloadDocument(params);
	}

	getActivityLog(pageable: Pageable, caseId: number): Observable<EventLogResponse> {
		return this.eventLogServ.getApplicationEventLogsBycaseId(pageable, caseId);
	}

	setRelatedCaseIdsList = (relatedCasesChargeIdsList: number[]) =>
		(this.relatedCaseIdsList = relatedCasesChargeIdsList);

	getRelatedCaseIdsList = (): number[] => this.relatedCaseIdsList;

	updateLinkedCaseIdsList = (chargeInquiryId: number) => {
		this.linkedCaseIdsList.push(chargeInquiryId);
		this.unLinkedCaseIdsList = this.unLinkedCaseIdsList.filter((element) => element !== chargeInquiryId);
	};

	getLinkedCaseIdsList = (): number[] => this.linkedCaseIdsList;

	updateUnLinkedCaseIdsList = (chargeInquiryId: number) => {
		this.unLinkedCaseIdsList.push(chargeInquiryId);
		this.linkedCaseIdsList = this.linkedCaseIdsList.filter((element) => element !== chargeInquiryId);
	};

	getUnLinkedCaseIdsList = (): number[] => this.unLinkedCaseIdsList;

	/**
	 * @description get allegations by caseId
	 */
	getAllegations(caseId: number): Observable<AllegationVO[]> {
		return this.allegationserv.getAllegationsByCaseId(caseId);
	}

	/**
	 * @description search charges with given search criteria
	 * @param caseCriteria
	 * @returns
	 */
	getChargesByCriteria(caseCriteria: SystemicCaseCriteria): Observable<Array<SystemicCriteriaCharges>> {
		return this.systemicServ.getChargesByCriteria(caseCriteria);
	}

	getSystemicEventLogs(id: number) {
		return this.systemicEventLogServ.getSystemicEventLogs(id);
	}
}
